import ApiNode from './ApiNode'

export default {
  addExpenseDocument(payload) {
    return ApiNode().post('payment-request/expense', payload)
  },
  addAdditionalTask(payload) {
    return ApiNode().post('payment-request/additional-task', payload)
  },
  addSlinePaymentRequest(payload) {
    return ApiNode().post('payment-request/sline', payload)
  },
  getPurchaseExpense(payload) {
    return ApiNode().post('payment-request/purchase-expense-child', payload)
  },
  // Purchase Approval - r_purchase_expense_approval
  upsertApproval(payload) {
    return ApiNode().post('payment-request/approval/upsert', payload)
  },
  paymentComplete(payload) {
    return ApiNode().post('payment-request/payment-complete', payload)
  },
  multiPaymentComplete(payload) {
    return ApiNode().post('payment-request/multi-payment-complete', payload)
  },
  getLockPanelEmailDetails(payload) {
    return ApiNode().post('payment-request/get-lock-panel-details', payload)
  },
  getAllOldExpAdd(payload) {
    return ApiNode().post('payment-request/old-exp-add', payload)
  },
  listApprovals(params = {}) {
    return ApiNode().post('payment-request/approval-list', params)
    // return ApiNode().get('payment-request/approval-list', { params })
  },
  
  getPaymentRequestExcellList(params, config) {
    // Support blob responseType for Excel downloads
    const defaultConfig = Object.assign({ responseType: 'blob' }, config || {})
    return ApiNode().get('payment-request/payment-request-list', params || {}, {})
  },
  getApprovalById(pea_id) {
    return ApiNode().get(`payment-request/approval/${pea_id}`)
  },
  deleteApproval(pea_id) {
    return ApiNode().delete(`payment-request/approval/${pea_id}`)
  },
  deletePurchaseExpense(payload) {
    return ApiNode().post(`payment-request/purchase/remove`, payload)
  },
  deleteConsignee(payload) {
    return ApiNode().post(`payment-request/remove-consignee`, payload)
  },
  // Bookmarks
  getBookmarks(payload = {}) {
    return ApiNode().post('payment-request/bookmark/list', payload)
  },
  upsertBookmark(payload) {
    // expected payload: { transactionId: string|number, isBookmarked: boolean }
    return ApiNode().post('payment-request/bookmark/upsert', payload)
  },
  getBookmarkedPayments(payload = {}) {
    // expected payload can include pagination/filtering similar to getPurchaseExpense
    return ApiNode().post('payment-request/bookmark/list', payload)
  },
  
}



// WEBPACK FOOTER //
// ./src/services/PaymentRequestService.js